import { JSSManager } from "./jss-manager";
/* eslint-disable-next-line @typescript-eslint/no-var-requires */
const hoistNonReactStatics = require("hoist-non-react-statics");
/**
 * Main entry into the style manager. This function accepts a JSS style object and returns a
 * higher order component. That higher-order component can then be used to compose a component
 * with styles managed
 * @param S - The stylesheet class-name contract
 * @param C - The stylesheet design-system configuration object
 */
function manageJss(styles) {
    return function (Component) {
        class JSSManagedComponent extends JSSManager {
            constructor() {
                super(...arguments);
                this.styles = styles;
                this.managedComponent = Component;
            }
        }
        JSSManagedComponent.displayName = `withJSS(${Component.displayName || Component.name})`;
        return hoistNonReactStatics(JSSManagedComponent, Component);
    };
}
export { manageJss };
